import { connect } from 'react-redux';
// import {
//   requestProductDetail,
//   requestCreateProductOffers,
//   createSavingGoal,
//   requestPaymentSchedule,
// } from 'src/redux/actions';
import ContactUs from './contactUs';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(ContactUs);
